// removed by extract-text-webpack-plugin
module.exports = {"container":"_18985NKl2IoiFjqI3Z4uZA","button":"_1sKAZGyElLp6j765C0BAiD","divCancelar":"_3DlDY8JABapsQ2fENkH6hd","btnCancelar":"_2N28z8jm0ANYSEym2S8KQV","twoFactor":"_1-jyzuf5SMU0BSdRSWbobZ","feaState":"_2sv1Lsmey7olTwqM6xoJYV"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/styles.css
// module id = 2907
// module chunks = 0